const blue = {
  50: "#E5ECF3",
  100: "#CCDAE7",
  200: "#B2C7DB",
  300: "#99B5CF",
  400: "#7FA2C2",
  500: "#6690B7",
  600: "#4D7EAB",
  // 700 and above text is WCAG AA accessible on white backgrounds.
  700: "#336B9E",
  // 800 and above text is WCAG AAA accessible on white backgrounds.
  800: "#1A5992",
  900: "#004686"
};

export default blue;
